import { expVal } from '@atlassian/jira-feature-experiments';
import { messages } from '../../common/ui/request-access-prompt-flag/messages.tsx';

interface VariableMessagingKey {
	title: keyof typeof messages;
	description: keyof typeof messages;
	joinButton: keyof typeof messages;
}

export const EntityList = [
	'nudgeCandidate01',
	'nudgeCandidate02',
	'nudgeCandidate03',
	'nudgeCandidate04',
	'nudgeCandidate05',
	'nudgeCandidate06',
	'nudgeCandidate07',
] as const;

export type EntityId = (typeof EntityList)[number] | 'default';

type EntityIdGalaxia =
	| EntityId
	| 'defaultGalaxia'
	| 'nudgeCandidate01Galaxia'
	| 'nudgeCandidate02Galaxia'
	| 'nudgeCandidate03Galaxia'
	| 'nudgeCandidate04Galaxia'
	| 'nudgeCandidate05Galaxia'
	| 'nudgeCandidate06Galaxia'
	| 'nudgeCandidate07Galaxia';

const messageVariantsKeyMap: Record<EntityIdGalaxia, VariableMessagingKey> = {
	default: {
		title: 'title',
		description: 'description',
		joinButton: 'joinButton',
	},
	nudgeCandidate01: {
		title: 'titleNudgeCandidate01',
		description: 'descriptionNudgeCandidate01',
		joinButton: 'joinButtonNudgeCandidate01',
	},
	nudgeCandidate02: {
		title: 'titleNudgeCandidate02',
		description: 'descriptionNudgeCandidate02',
		joinButton: 'joinButtonNudgeCandidate02',
	},
	nudgeCandidate03: {
		title: 'titleNudgeCandidate03',
		description: 'descriptionNudgeCandidate03',
		joinButton: 'joinButtonNudgeCandidate03',
	},
	nudgeCandidate04: {
		title: 'titleNudgeCandidate04',
		description: 'descriptionNudgeCandidate04',
		joinButton: 'joinButtonNudgeCandidate04',
	},
	nudgeCandidate05: {
		title: 'titleNudgeCandidate05',
		description: 'descriptionNudgeCandidate05',
		joinButton: 'joinButtonNudgeCandidate05',
	},
	nudgeCandidate06: {
		title: 'titleNudgeCandidate06',
		description: 'descriptionNudgeCandidate06',
		joinButton: 'joinButtonNudgeCandidate06',
	},
	nudgeCandidate07: {
		title: 'titleNudgeCandidate07',
		description: 'descriptionNudgeCandidate07',
		joinButton: 'joinButtonNudgeCandidate07',
	},
	defaultGalaxia: {
		title: 'title',
		description: 'descriptionGalaxia',
		joinButton: 'joinButton',
	},
	nudgeCandidate01Galaxia: {
		title: 'titleNudgeCandidate01',
		description: 'descriptionNudgeCandidate01Galaxia',
		joinButton: 'joinButtonNudgeCandidate01',
	},
	nudgeCandidate02Galaxia: {
		title: 'titleNudgeCandidate02',
		description: 'descriptionNudgeCandidate02',
		joinButton: 'joinButtonNudgeCandidate02',
	},
	nudgeCandidate03Galaxia: {
		title: 'titleNudgeCandidate03',
		description: 'descriptionNudgeCandidate03Galaxia',
		joinButton: 'joinButtonNudgeCandidate03',
	},
	nudgeCandidate04Galaxia: {
		title: 'titleNudgeCandidate04Galaxia',
		description: 'descriptionNudgeCandidate04Galaxia',
		joinButton: 'joinButtonNudgeCandidate04',
	},
	nudgeCandidate05Galaxia: {
		title: 'titleNudgeCandidate05Galaxia',
		description: 'descriptionNudgeCandidate05Galaxia',
		joinButton: 'joinButtonNudgeCandidate05',
	},
	nudgeCandidate06Galaxia: {
		title: 'titleNudgeCandidate06',
		description: 'descriptionNudgeCandidate06',
		joinButton: 'joinButtonNudgeCandidate06',
	},
	nudgeCandidate07Galaxia: {
		title: 'titleNudgeCandidate07',
		description: 'descriptionNudgeCandidate07Galaxia',
		joinButton: 'joinButtonNudgeCandidate07',
	},
};

export const getDynamicMessages = (isContextualBandit: boolean, entityId: EntityId) => {
	// Handle case when entityId is unexpected
	if (!(entityId in messageVariantsKeyMap)) {
		return undefined;
	}
	// If v2B is not enabled we just passthrough default message keys
	const usedEntityId: EntityId = isContextualBandit ? entityId : 'default';

	// if experiment is enabled and usedEntityIdGalaxia exists then use it
	// else use the usedEntityId
	const entityIdToUse: EntityIdGalaxia = expVal('project-terminology-refresh', 'isEnabled', false)
		? `${usedEntityId}Galaxia`
		: usedEntityId;

	const titleKey = messageVariantsKeyMap[entityIdToUse].title;
	const descriptionKey = messageVariantsKeyMap[entityIdToUse].description;
	const joinButtonKey = messageVariantsKeyMap[entityIdToUse].joinButton;

	return {
		title: messages[titleKey],
		description: messages[descriptionKey],
		joinButton: messages[joinButtonKey],
	};
};
